import { Action } from "redux";

import * as FetchActions from "../actions/FetchActions";
import * as ProcessListActions from "../actions/ProcessListActions";

import * as _ from "lodash";

export function loading(state: string[] = [], action: Action): string[] {
    switch (action.type) {
        case FetchActions.FETCH_ERROR:
            return [];

        case FetchActions.FETCH_FINISH:
        case ProcessListActions.FINISH_LIST_ACTION: {
            const fetchAction = action as FetchActions.FetchAction;
            return _.without(state, fetchAction.actionId);
        }
        case FetchActions.FETCH_START:
        case ProcessListActions.START_LIST_ACTION: {
            const fetchFinishedAction = action as FetchActions.FetchAction;
            return state.concat([fetchFinishedAction.actionId]);
        }


        default:
            return state;
    }
}
